import { combineReducers } from '@reduxjs/toolkit';
import authReducer, { AuthState } from './authSlice';
import blockReducer, { BlockState } from './blockSlice';
import errorReducer, { ErrorState } from './errorSlice';
import photoReducer, { PhotoState } from './photoSlice';
import paymentReducer, { PaymentState } from './paymentSlice';
import themeReducer, { ThemeState } from './themeSlice';

const rootReducer = combineReducers({
  photo: photoReducer,
  auth: authReducer,
  block: blockReducer,
  error: errorReducer,
  payment: paymentReducer,
  theme: themeReducer,
});

export type RootState = {
  auth: AuthState;
  block: BlockState;
  photo: PhotoState;
  error: ErrorState;
  payment: PaymentState;
  theme: ThemeState;
};

export default rootReducer;
